import { renderSectionHeaderAsOfDate, renderRowGaps, renderMainLeftCell, renderMainRightCell } from '../helpers';
import { percentSingleDecimal } from '../download-data-styles';

export const renderAssetMixRow = asset => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(asset.assetTypeLabel);
  rowString += renderMainRightCell(asset.percent, percentSingleDecimal);
  rowString += '</tr>';
  return rowString;
};

export const assetMixModule = data => {
  let assetMixString = ``;
  assetMixString += renderSectionHeaderAsOfDate(data.sectionLabel, `As of ${data.asOfDate} (updated quarterly)`);
  assetMixString += renderRowGaps(1);
  data.assetMix.forEach(asset => {
    assetMixString += renderAssetMixRow(asset);
  });
  assetMixString += renderRowGaps(2);
  return assetMixString;
};
